import getSymbolFromCurrency from 'currency-symbol-map'

export const getCurrencySymbol = currency => (currency ? getSymbolFromCurrency(currency) : '')
